import React, { useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import * as resumeService from '../../services/resumeService';
import { toast } from 'react-toastify';

export default function ShareModal({ isOpen, onClose, resume }) {
	const [isPublic, setIsPublic] = useState(!!resume?.isPublic);
	const [link, setLink] = useState(resume?.shareableLink ? `${window.location.origin}/resume/${resume.shareableLink}` : '');

	async function toggle() {
		try {
			const res = await resumeService.togglePublic(resume._id);
			const r = res.resume;
			setIsPublic(r.isPublic);
			setLink(r.isPublic && r.shareableLink ? `${window.location.origin}/resume/${r.shareableLink}` : '');
		} catch {
			toast.error('Failed to toggle');
		}
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Share Resume">
			<div className="space-y-3">
				<label className="flex items-center gap-2">
					<input type="checkbox" checked={isPublic} onChange={toggle} />
					Make Public
				</label>
				{isPublic ? (
					<div>
						<label className="block text-sm text-gray-600 mb-1">Shareable Link</label>
						<div className="flex items-center gap-2">
							<input className="flex-1 border rounded px-3 py-2" readOnly value={link} />
							<Button variant="ghost" onClick={() => { navigator.clipboard.writeText(link); toast.success('Copied'); }}>
								Copy
							</Button>
						</div>
						<p className="text-xs text-gray-500 mt-1">Public resumes can be viewed by anyone with the link.</p>
					</div>
				) : (
					<p className="text-sm text-gray-600">Make your resume public to share it easily with recruiters.</p>
				)}
			</div>
		</Modal>
	);
}


